import { render } from "./BookingHistory.vue?vue&type=template&id=8ebd42c4"
import script from "./BookingHistory.vue?vue&type=script&lang=js"
export * from "./BookingHistory.vue?vue&type=script&lang=js"

import "./BookingHistory.vue?vue&type=style&index=0&id=8ebd42c4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__